import classNames from 'classnames';

export default function LevelLeft(props: {
    children?: any,
    className?: string,
    onClick?: () => void
}) {
    let className = props.className ?? '';

    const classes = classNames('level-left', {
        [className]: className.length
    });

    return (
        <div className={classes} onClick={props.onClick}>
            {props.children}
        </div>
    );
}
